// Copyright (c) 2026 Michael F. Kamprath
//
// Entry point for the Ewe Can Count web app.
// Phase 1a: bootstraps the app shell, PixiJS canvas, and home screen.

import { initApp } from './app.js';
import { registerServiceWorker } from './pwa-register.js';

function bootstrap() {
  const root = document.getElementById('app');
  if (!root) {
    console.error('[Ewe Can Count] #app element not found');
    return;
  }

  // iOS Safari needs at least one touchstart listener on the document
  // for :active styles and tap events to fire reliably.
  document.addEventListener('touchstart', () => {}, { passive: true });

  initApp(root);

  // Service worker registration is fire-and-forget. SW failures must
  // never block the app from rendering.
  registerServiceWorker();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootstrap, { once: true });
} else {
  bootstrap();
}
